// header-hover-dropdown.js
// Finds menu summary items containing "grocery" (case-insensitive)
// and opens their parent <details> on mouseenter, closes on mouseleave.
// Also adds touch support: tap toggles the menu on touch devices.

(function() {
  function matchesGroceryText(str) {
    return /grocery/i.test((str || '').trim());
  }

  function initHoverDropdowns() {
    // Query likely summary/menu elements used in the header
    var summaries = Array.from(document.querySelectorAll('summary, .list-menu__item--link, .list-menu__item'));

    summaries.forEach(function(summary) {
      try {
        var text = summary.textContent || summary.innerText || '';
        if (!matchesGroceryText(text)) return;

        // Find parent details element (for <details>/<summary> patterns)
        var details = summary.closest('details') || summary.parentElement;
        if (!details) return;

        // Add hover handlers (desktop)
        summary.addEventListener('mouseenter', function() {
          if (details.hasAttribute('open') || details.open) return;
          // open the details
          if (typeof details.open !== 'undefined') details.open = true;
          details.setAttribute('open', '');
          // set aria-expanded if present on the summary
          if (summary.setAttribute) summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('mouseleave', function() {
          if (typeof details.open !== 'undefined') details.open = false;
          details.removeAttribute('open');
          if (summary.setAttribute) summary.setAttribute('aria-expanded', 'false');
        });

        // Small delay-safe touch support: first touch opens, second touch follows link (if any)
        var touchToggle = function(e) {
          // If it's already open, allow normal click to proceed
          if (details.open) return;
          e.preventDefault();
          if (typeof details.open !== 'undefined') details.open = true;
          details.setAttribute('open', '');
          if (summary.setAttribute) summary.setAttribute('aria-expanded', 'true');

          // Close when tapping outside
          var onDocTouch = function(ev) {
            if (!details.contains(ev.target)) {
              details.open = false;
              details.removeAttribute('open');
              if (summary.setAttribute) summary.setAttribute('aria-expanded', 'false');
              document.removeEventListener('touchstart', onDocTouch);
            }
          };
          document.addEventListener('touchstart', onDocTouch);
        };

        summary.addEventListener('touchstart', touchToggle, {passive: false});

        // Prevent accidental closing when moving pointer between child elements
        details.addEventListener('mouseenter', function() { /* no-op but keeps hover state reliable */ });

      } catch (err) {
        // ignore errors for non-standard DOM
        console.error('hover-dropdown init error', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverDropdowns);
  } else {
    initHoverDropdowns();
  }
})();
